import React, { Fragment } from "react";
import PromptPanel from "./PromptPanel.tsx";
import FavouriteQuestion from "./FavouriteQuestion.tsx";
import ShowMemories from "./ShowMemories.tsx";
import Graph from "./Graph.tsx";
import SyncStatus from "./SyncStatus.tsx";
import { Exchange } from "../../store/types.tsx";
import Table from "./Table.tsx";

interface ResponsePromptProps {
  children?: React.ReactNode;
  exchange: Exchange;
}

const ResponsePrompt: React.FC<ResponsePromptProps> = (props) => {
  let content = null;
  let type = null;
  if (
    props.exchange.json_response !== undefined &&
    props.exchange.json_response !== null
  ) {
    content = props.exchange.json_response.content;
    type = props.exchange.json_response.type;
  } else if (
    props.exchange.response !== undefined &&
    props.exchange.response !== null
  ) {
    content = props.exchange.response;
    type = props.exchange.type;
  }
  if (!content) {
    return <Fragment />;
  } else if (type === undefined || type === "TextResponse") {
    return (
      <PromptPanel
        key={`assistant_${props.exchange.id}`}
        role="assistant"
        content={content as string}
        exchange_id={props.exchange.id}
        feedback={props.exchange.feedback}
        user_comment={props.exchange.user_comment}
        progress_update={props.exchange.progress_update}
      ></PromptPanel>
    );
  } else if (type === "FavouriteQuestion") {
    return (
      <FavouriteQuestion role="assistant" content={content as Array<any>} />
    );
  } else if (type === "Memory") {
    return <ShowMemories role="assistant" content={content as Array<any>} />;
  } else if (type === "SyncStatus") {
    return <SyncStatus role="assistant" content={content} />;
  } else if (type === "Graph") {
    return (
      <Graph
        content={content}
        feedback={props.exchange.feedback}
        exchange_id={props.exchange.id}
      />
    );
  } else if (type === "Table") {
    return (
      <Table
        content={content}
        feedback={props.exchange.feedback}
        exchange_id={props.exchange.id}
      />
    );
  }
};

export default ResponsePrompt;
